import React from "react";
import {
  Box, Typography, GridLegacy as Grid, CardContent, Container, Card, List, ListItem, ListItemText, ListItemIcon,
} from "@mui/material";

import LanguageIcon from "@mui/icons-material/Language";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import PsychologyIcon from "@mui/icons-material/Psychology";
import {
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export default function SwServices() {
  const { t } = useTranslation();
  const swserviceT = (key: string) => t(`swservice:${key}`);

  const services = [
    {
      icon: <LanguageIcon color="primary" fontSize="large" />,
      title: swserviceT("swService1Title"),
      desc: swserviceT("swService1Desc")
    },
    {
      icon: <PhoneIphoneIcon color="primary" fontSize="large" />,
      title: swserviceT("swService2Title"),
      desc: swserviceT("swService2Desc")
    },
    {
      icon: <PsychologyIcon color="primary" fontSize="large" />,
      title: swserviceT("swService3Title"),
      desc: swserviceT("swService3Desc")
    },
  ];

  const benefits = [
    swserviceT("swBenefit1"),
    swserviceT("swBenefit2"),
    swserviceT("swBenefit3"),
    swserviceT("swBenefit4"),
    swserviceT("swBenefit5"),
    swserviceT("swBenefit6")
  ];

  return (
    <Box sx={{ overflow: "hidden", background: "transparent", pl: 0 }}>
      <Box
        sx={{
          background: `
                linear-gradient(90deg, #f8fafc 0%, transparent 25%),
                linear-gradient(270deg, #f8fafc 0%, transparent 25%),
                linear-gradient(180deg, cadetblue 0%, transparent 80%)
              `,
          backdropFilter: "blur(10px)",
          py: { xs: 2, md: 6 },
          textAlign: "center",
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h2" sx={{ pb: 2 }}>
            {swserviceT("swHeroTitle")}
          </Typography>
          <Typography variant="h6" sx={{ mx: "auto", opacity: 0.9, textAlign: "justify" }} pb={2}>
            {swserviceT("swHeroDescription")}
          </Typography>
        </Container>
      </Box>
      
      <Container>
        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  transition: "all 0.3s ease",
                  "&:hover": { transform: "translateY(-6px)", boxShadow: 4 },
                }}
              >
                <CardContent sx={{ textAlign: "center" }}>
                  <Box sx={{ mb: { xs: 1, md: 2 } }}>{service.icon}</Box>
                  <Typography variant="h5" sx={{ pb: 1 }}>
                    {service.title}
                  </Typography>
                  <Typography variant="h6" textAlign={"center"} pb={2} pl={2} pr={2} lineHeight={1.8}>
                    {service.desc}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Why Choose Us Section */}
      <Box sx={{ backgroundColor: "transparent", py: { xs: 4, md: 8 } }}>
        <Container maxWidth="lg">
          <Box sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
          }}>
            {/* Left side: Text */}
            <Box sx={{ flex: 1 }}>
              <Typography variant="h3" fontWeight="bold" sx={{ mb: { xs: 1, md: 4 } }}>
                {swserviceT("swWhyChooseTitle")}
              </Typography>
              <List dense>
                {benefits.map((benefit, index) => (
                  <ListItem key={index} sx={{ px: 0, py: 0 }}>
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      <CheckCircleIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={benefit} />
                  </ListItem>
                ))}
              </List>
            </Box>

            {/* Right side: Image */}
            <Box sx={{
              flex: 1,
              display: { xs: "none", md: "block" }
            }}>
              <img
                src="/logos/software1.jpg"
                alt={swserviceT("swImageAlt")}
                style={{
                  width: "100%",
                  maxWidth: "600px",
                  height: "auto",
                  borderRadius: "12px",
                }}
              />
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}